import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, normalizeClass as _normalizeClass, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, normalizeStyle as _normalizeStyle, unref as _unref } from "vue"

const _hoisted_1 = { class: "ev-owner-statistics" }
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = { class: "header-content" }
const _hoisted_4 = { class: "title-block" }
const _hoisted_5 = { class: "subtitle" }
const _hoisted_6 = { class: "header-actions" }
const _hoisted_7 = { class: "date-tools" }
const _hoisted_8 = { class: "presets" }
const _hoisted_9 = ["disabled", "onClick"]
const _hoisted_10 = { class: "date-input-row" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  key: 0,
  class: "kpi-grid"
}
const _hoisted_13 = { class: "kpi-icon" }
const _hoisted_14 = { class: "kpi-body" }
const _hoisted_15 = { class: "kpi-title" }
const _hoisted_16 = { class: "kpi-value" }
const _hoisted_17 = { class: "panel" }
const _hoisted_18 = { class: "panel-head static" }
const _hoisted_19 = { class: "panel-title" }
const _hoisted_20 = { class: "title-with-sub" }
const _hoisted_21 = { class: "desc" }
const _hoisted_22 = { class: "panel-body" }
const _hoisted_23 = {
  key: 0,
  class: "inline-loader"
}
const _hoisted_24 = {
  key: 1,
  class: "empty"
}
const _hoisted_25 = { class: "mini-stats" }
const _hoisted_26 = { class: "mini-stat" }
const _hoisted_27 = { class: "mini-stat" }
const _hoisted_28 = { class: "mini-stat" }
const _hoisted_29 = { class: "mini-stat" }
const _hoisted_30 = { class: "mini-stat" }
const _hoisted_31 = {
  key: 0,
  class: "single-bucket"
}
const _hoisted_32 = { class: "single-bucket-info" }
const _hoisted_33 = { class: "sb-label" }
const _hoisted_34 = { class: "sb-date" }
const _hoisted_35 = { class: "single-bucket-value" }
const _hoisted_36 = {
  key: 1,
  class: "chart-wrapper"
}
const _hoisted_37 = { class: "chart-legend" }
const _hoisted_38 = { class: "lg-item" }
const _hoisted_39 = {
  key: 0,
  class: "lg-tooltip"
}
const _hoisted_40 = { class: "chart-with-axes" }
const _hoisted_41 = { class: "y-axis" }
const _hoisted_42 = { class: "y-axis-caption" }
const _hoisted_43 = { class: "chart-area" }
const _hoisted_44 = { class: "bar-chart" }
const _hoisted_45 = { class: "avg-line-label" }
const _hoisted_46 = ["onMouseenter"]
const _hoisted_47 = { class: "bar-value" }
const _hoisted_48 = { class: "bar-x-axis" }
const _hoisted_49 = {
  key: 2,
  class: "empty"
}
const _hoisted_50 = {
  key: 3,
  class: "empty"
}
const _hoisted_51 = { class: "panel" }
const _hoisted_52 = { class: "panel-body" }
const _hoisted_53 = {
  key: 0,
  class: "inline-loader"
}
const _hoisted_54 = {
  key: 1,
  class: "tod-layout"
}
const _hoisted_55 = { class: "donut-block" }
const _hoisted_56 = { class: "donut-center" }
const _hoisted_57 = { class: "donut-total" }
const _hoisted_58 = { class: "segments-list" }
const _hoisted_59 = { class: "segment-info" }
const _hoisted_60 = { class: "segment-top" }
const _hoisted_61 = { class: "segment-sub" }
const _hoisted_62 = { class: "hourly-block" }
const _hoisted_63 = { class: "hourly-head" }
const _hoisted_64 = {
  key: 0,
  class: "off-hours-pill"
}
const _hoisted_65 = { class: "hourly-chart" }
const _hoisted_66 = { class: "y-axis hourly-y" }
const _hoisted_67 = { class: "hourly-bars" }
const _hoisted_68 = ["onMouseenter"]
const _hoisted_69 = { class: "hour-label" }
const _hoisted_70 = {
  key: 2,
  class: "empty"
}
const _hoisted_71 = { class: "car-selector-section" }
const _hoisted_72 = { key: 0 }
const _hoisted_73 = {
  key: 0,
  class: "kpi-grid"
}
const _hoisted_74 = { class: "kpi-icon" }
const _hoisted_75 = { class: "kpi-body" }
const _hoisted_76 = { class: "kpi-title" }
const _hoisted_77 = { class: "kpi-value" }
const _hoisted_78 = {
  key: 1,
  class: "panel"
}
const _hoisted_79 = { class: "panel-body" }
const _hoisted_80 = {
  key: 0,
  class: "inline-loader"
}
const _hoisted_81 = {
  key: 1,
  class: "empty"
}
const _hoisted_82 = { class: "mini-stats" }
const _hoisted_83 = { class: "mini-stat" }
const _hoisted_84 = { class: "mini-stat" }
const _hoisted_85 = { class: "mini-stat" }
const _hoisted_86 = { class: "mini-stat" }
const _hoisted_87 = { class: "mini-stat" }
const _hoisted_88 = {
  key: 0,
  class: "single-bucket"
}
const _hoisted_89 = { class: "single-bucket-info" }
const _hoisted_90 = { class: "sb-date" }
const _hoisted_91 = { class: "sb-sub" }
const _hoisted_92 = { class: "single-bucket-value" }
const _hoisted_93 = {
  key: 1,
  class: "chart-wrapper"
}
const _hoisted_94 = { class: "chart-legend" }
const _hoisted_95 = { class: "lg-item" }
const _hoisted_96 = {
  key: 0,
  class: "lg-tooltip"
}
const _hoisted_97 = { class: "chart-with-axes" }
const _hoisted_98 = { class: "y-axis" }
const _hoisted_99 = { class: "y-axis-caption" }
const _hoisted_100 = { class: "chart-area" }
const _hoisted_101 = { class: "bar-chart" }
const _hoisted_102 = { class: "avg-line-label" }
const _hoisted_103 = ["onMouseenter"]
const _hoisted_104 = { class: "bar-value" }
const _hoisted_105 = { class: "bar-x-axis" }
const _hoisted_106 = {
  key: 3,
  class: "empty"
}
const _hoisted_107 = {
  key: 2,
  class: "panel"
}
const _hoisted_108 = { class: "panel-body" }
const _hoisted_109 = {
  key: 0,
  class: "inline-loader"
}
const _hoisted_110 = {
  key: 1,
  class: "tod-layout"
}
const _hoisted_111 = { class: "donut-block" }
const _hoisted_112 = { class: "donut-center" }
const _hoisted_113 = { class: "donut-total" }
const _hoisted_114 = { class: "segments-list" }
const _hoisted_115 = { class: "segment-info" }
const _hoisted_116 = { class: "segment-top" }
const _hoisted_117 = { class: "segment-sub" }
const _hoisted_118 = {
  key: 0,
  class: "off-hours-pill"
}
const _hoisted_119 = { class: "hourly-block" }
const _hoisted_120 = { class: "hourly-head" }
const _hoisted_121 = {
  key: 0,
  class: "off-hours-pill"
}
const _hoisted_122 = { class: "hourly-chart" }
const _hoisted_123 = { class: "hourly-y" }
const _hoisted_124 = { class: "hourly-bars" }
const _hoisted_125 = ["onMouseenter"]
const _hoisted_126 = { class: "hour-label" }
const _hoisted_127 = {
  key: 2,
  class: "empty"
}

import { ref, computed, onMounted, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { DateTime } from 'luxon'
import {
  Timer,
  Money,
  Odometer,
  User as UserIcon,
  Van,
  OfficeBuilding,
  Loading,
} from '@element-plus/icons-vue'
import { ElMessage } from 'element-plus'

import CommonError from '@/components/CommonError.vue'

import {
  getOwnerStatisticsCars,
  getOwnerStatistics,
  getOwnerStatisticsByCar,
  getOwnerTripIntervals,
  getOwnerTimeOfDay,
} from '@/api/car-ev-data'

import { useAuthStore } from '@/store/auth'

interface IntervalBar {
  label: string
  shortDate: string
  value: number
  count: number
  heightPct: number
  above: boolean
  shortValue: string
  showLabel: boolean
}

const EXCLUDED_COLOR = '#94a3b8'

export default /*@__PURE__*/_defineComponent({
  __name: 'EVOwnerStatistics',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const authStore = useAuthStore()

// Tabs
const normalizeOwnerTab = (val: unknown): 'general' | 'by-car' => {
  const s = Array.isArray(val) ? val[0] : String(val ?? '')
  if (s === 'general' || s === 'by-car') return s
  const saved = localStorage.getItem('ev-owner-stats-active-tab')
  if (saved === 'general' || saved === 'by-car') return saved
  return 'general'
}

const activeTab = ref<'general' | 'by-car'>(normalizeOwnerTab(route.query.tab))
const selectedCarId = ref<string>('')

// URL -> UI
watch(
  () => route.query.tab,
  q => {
    const next = normalizeOwnerTab(q)
    if (next !== activeTab.value) activeTab.value = next
  }
)

// Watch for tab changes and save to localStorage + URL
watch(
  activeTab,
  (newTab: 'general' | 'by-car') => {
    localStorage.setItem('ev-owner-stats-active-tab', newTab)
    const current = Array.isArray(route.query.tab)
      ? route.query.tab[0]
      : route.query.tab
    if (current !== newTab) {
      router.replace({
        path: route.path,
        query: { ...route.query, tab: newTab },
      })
    }
  },
  { immediate: true }
)

// Data
const cars = ref<any[]>([])
const overview = ref<any>(null)
const carOverview = ref<any>(null)
const intervals = ref<any>(null)
const carIntervals = ref<any>(null)
const timeOfDay = ref<any>(null)
const carTimeOfDay = ref<any>(null)
const meta = ref<any>(null)
const error = ref<string | null>(null)
const intervalsGrouping = ref<'daily' | 'weekly' | 'monthly'>('daily')

// Loading states
const loading = ref({
  cars: false,
  overview: false,
  carOverview: false,
  intervals: false,
  carIntervals: false,
  timeOfDay: false,
  carTimeOfDay: false,
})

// Date range
const rangeModel = ref<Date[]>([
  DateTime.now()
    .minus({ days: 36500 })
    .toJSDate(),
  DateTime.now().toJSDate(),
])
const activePreset = ref('all')

const presets = [
  { key: '1d', label: 'Day', days: 1 },
  { key: '7d', label: 'Week', days: 7 },
  { key: '90d', label: '90 Days', days: 90 },
  { key: 'all', label: 'All', days: 36500 }, // 100 years = effectively all time
]

const dateShortcuts = [
  {
    text: 'Today',
    value: () => {
      const end = new Date()
      const start = new Date()
      return [start, end]
    },
  },
  {
    text: 'Last 7 Days',
    value: () => {
      const end = new Date()
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
      return [start, end]
    },
  },
  {
    text: 'Last 90 Days',
    value: () => {
      const end = new Date()
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
      return [start, end]
    },
  },
  {
    text: 'All Time',
    value: () => {
      const end = new Date()
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 365 * 100) // 100 years
      return [start, end]
    },
  },
]

const kpiList = computed(() => {
  const data = activeTab.value === 'by-car' ? carOverview.value : overview.value
  if (!data) return []

  return [
    {
      key: 'vehicles',
      title: 'Vehicles',
      value: data.totalVehicles || 0,
      icon: Van,
      color: '#6366f1',
    },
    {
      key: 'trips',
      title: 'Trips',
      value: data.totalTrips || 0,
      icon: Timer,
      color: '#f59e0b',
    },
    {
      key: 'revenue',
      title: 'Revenue',
      value: `${(data.revenue || 0).toFixed(2)}₼`,
      icon: Money,
      color: '#10b981',
    },
    {
      key: 'duration',
      title: 'Avg trip duration',
      value: `${(data.avgTripDurationMinutes || 0).toFixed(1)} min`,
      icon: Timer,
      color: '#ec4899',
    },
    {
      key: 'distance',
      title: 'Avg trip distance',
      value: `${(data.avgTripDistanceKm || 0).toFixed(1)} km`,
      icon: Odometer,
      color: '#8b5cf6',
    },
  ]
})

const formatDateShort = (date: string) => {
  return DateTime.fromISO(date).toFormat('MMM dd')
}

const formatNumber = (value?: number | null): string => {
  if (value === null || value === undefined) return '0'
  return new Intl.NumberFormat('en-US').format(value)
}

const formatMinutes = (minutes?: number | null): string => {
  if (minutes === null || minutes === undefined) return '0m'
  const n = Math.round(minutes)
  if (n < 60) return `${n}m`
  const h = Math.floor(n / 60)
  const m = n % 60
  if (m === 0) return `${h}h`
  return `${h}h${m}`
}

const applyPreset = (key: string) => {
  const preset = presets.find(p => p.key === key)
  if (preset) {
    activePreset.value = key
    rangeModel.value = [
      DateTime.now()
        .minus({ days: preset.days })
        .toJSDate(),
      DateTime.now().toJSDate(),
    ]
    reloadAll()
  }
}

const onRangeChanged = () => {
  activePreset.value = ''
}

const reloadAll = async () => {
  if (activeTab.value === 'general') {
    await loadGeneralStats()
  } else if (selectedCarId.value) {
    await loadCarStats(selectedCarId.value)
  }
}

const loadGeneralStats = async () => {
  const [dateFrom, dateTo] = rangeModel.value || []
  if (!dateFrom || !dateTo) return

  const dateFromString = DateTime.fromJSDate(dateFrom).toFormat('yyyy-MM-dd')
  const dateToString = DateTime.fromJSDate(dateTo).toFormat('yyyy-MM-dd')

  loading.value.overview = true
  loading.value.intervals = true
  loading.value.timeOfDay = true
  error.value = null

  try {
    const [overviewRes, intervalsRes, timeRes] = await Promise.all([
      getOwnerStatistics({
        date_from: dateFromString,
        date_to: dateToString,
      }),
      getOwnerTripIntervals({
        date_from: dateFromString,
        date_to: dateToString,
        grouping: intervalsGrouping.value,
      }),
      getOwnerTimeOfDay({
        date_from: dateFromString,
        date_to: dateToString,
      }),
    ])

    overview.value = overviewRes.data
    meta.value = overviewRes.meta
    intervals.value = intervalsRes.data
    timeOfDay.value = timeRes.data
  } catch (e) {
    const err = e as any
    console.error('Failed to load general stats:', err)
    error.value =
      err?.response?.data?.message ||
      err?.message ||
      'Failed to load statistics'
    intervals.value = null
    timeOfDay.value = null
  } finally {
    loading.value.overview = false
    loading.value.intervals = false
    loading.value.timeOfDay = false
  }
}

const loadIntervals = async (force = false) => {
  if (!force && intervals.value) return
  const [dateFrom, dateTo] = rangeModel.value || []
  if (!dateFrom || !dateTo) return

  const dateFromString = DateTime.fromJSDate(dateFrom).toFormat('yyyy-MM-dd')
  const dateToString = DateTime.fromJSDate(dateTo).toFormat('yyyy-MM-dd')

  loading.value.intervals = true
  try {
    const res = await getOwnerTripIntervals({
      date_from: dateFromString,
      date_to: dateToString,
      grouping: intervalsGrouping.value,
    })
    intervals.value = res.data
  } catch (e) {
    const err = e as any
    ElMessage.error(
      err?.response?.data?.message || err?.message || 'Failed to load intervals'
    )
  } finally {
    loading.value.intervals = false
  }
}

/* -------- Intervals chart (bars) -------- */
const hoveredBar = ref<(IntervalBar & { index: number }) | null>(null)

const hoveredBarDeltaPct = computed(() => {
  const avg = intervals.value?.avgIntervalMinutes || 0
  const v = hoveredBar.value?.value || 0
  if (!avg) return 0
  return Math.round(((v - avg) / avg) * 100)
})

const intervalsMaxY = computed(() => {
  const currentIntervals =
    activeTab.value === 'by-car' ? carIntervals.value : intervals.value
  const buckets = currentIntervals?.buckets ?? []
  if (!buckets.length) return 1
  return Math.max(...buckets.map((b: any) => b.avg_interval_minutes || 0), 1)
})

const intervalsYTicks = computed(() => {
  const max = intervalsMaxY.value
  return [1, 0.75, 0.5, 0.25, 0].map(r => formatMinutes(max * r))
})

const avgLinePct = computed(() => {
  const max = intervalsMaxY.value
  const currentIntervals =
    activeTab.value === 'by-car' ? carIntervals.value : intervals.value
  const avg = currentIntervals?.avgIntervalMinutes ?? 0
  if (!max) return 0
  return Math.min(100, (avg / max) * 100)
})

const formatShortMinutes = (v: number): string => {
  const n = Math.round(v)
  if (n < 60) return `${n}m`
  const h = Math.floor(n / 60)
  const m = n % 60
  if (m === 0) return `${h}h`
  return `${h}h${m}`
}

const formatBucketShortDate = (raw: string): string => {
  const d = DateTime.fromISO(raw)
  if (!d.isValid) return raw
  if (intervalsGrouping.value === 'monthly') return d.toFormat('MMM yy')
  if (intervalsGrouping.value === 'weekly') return d.toFormat('MMM dd')
  return d.toFormat('MMM dd')
}

const intervalBars = computed<IntervalBar[]>(() => {
  const currentIntervals =
    activeTab.value === 'by-car' ? carIntervals.value : intervals.value
  const buckets = currentIntervals?.buckets ?? []
  if (!buckets.length) return []
  const max = intervalsMaxY.value
  const avg = currentIntervals?.avgIntervalMinutes ?? 0
  const n = buckets.length
  const labelStep = Math.max(1, Math.ceil(n / 10))
  return buckets.map((b: any, i: number) => {
    const v = b.avg_interval_minutes || 0
    return {
      label: formatBucketShortDate(b.date),
      shortDate: formatBucketShortDate(b.date),
      value: v,
      count: b.intervals_count || 0,
      heightPct: max ? Math.max(2, (v / max) * 100) : 0,
      above: v >= avg,
      shortValue: formatShortMinutes(v),
      showLabel: i % labelStep === 0 || i === n - 1,
    }
  })
})

/* -------- Time of day derived -------- */
const SEGMENT_COLORS: Record<string, string> = {
  morning: '#fbbf24',
  afternoon: '#10b981',
  evening: '#6366f1',
}
const SEGMENT_LABELS: Record<string, string> = {
  morning: 'Morning (6–11)',
  afternoon: 'Afternoon (12–16)',
  evening: 'Evening (17–22)',
}

const SEGMENT_KEYS = ['morning', 'afternoon', 'evening']

const totalTodTrips = computed(() => {
  const currentTimeOfDay =
    activeTab.value === 'by-car' ? carTimeOfDay.value : timeOfDay.value
  const s = currentTimeOfDay?.segments
  if (!s) return 0
  return SEGMENT_KEYS.reduce((acc, k) => acc + (s[k]?.trips || 0), 0)
})

const excludedTrips = computed(() => {
  const currentTimeOfDay =
    activeTab.value === 'by-car' ? carTimeOfDay.value : timeOfDay.value
  return currentTimeOfDay?.excluded?.trips || 0
})
const excludedHoursRange = computed(() => {
  const currentTimeOfDay =
    activeTab.value === 'by-car' ? carTimeOfDay.value : timeOfDay.value
  return currentTimeOfDay?.excluded?.hours_range || '23:00–05:59'
})

const segmentList = computed(() => {
  const currentTimeOfDay =
    activeTab.value === 'by-car' ? carTimeOfDay.value : timeOfDay.value
  const s = currentTimeOfDay?.segments
  if (!s) return []
  const total = totalTodTrips.value || 1
  return SEGMENT_KEYS.map(k => ({
    key: k,
    label: SEGMENT_LABELS[k],
    color: SEGMENT_COLORS[k],
    trips: s[k]?.trips || 0,
    revenue: s[k]?.revenue || 0,
    avg_duration_minutes: s[k]?.avg_duration_minutes || 0,
    avg_distance_km: s[k]?.avg_distance_km || 0,
    percent: Math.round(((s[k]?.trips || 0) / total) * 100),
  }))
})

const donutGradient = computed(() => {
  const segs = segmentList.value
  const total = totalTodTrips.value || 1
  let acc = 0
  const stops: string[] = []
  segs.forEach(s => {
    const start = (acc / total) * 360
    acc += s.trips
    const end = (acc / total) * 360
    stops.push(`${s.color} ${start}deg ${end}deg`)
  })
  return `conic-gradient(${stops.join(', ') || '#e5e7eb 0deg 360deg'})`
})

const hourlyMax = computed(() => {
  const currentTimeOfDay =
    activeTab.value === 'by-car' ? carTimeOfDay.value : timeOfDay.value
  const hourly = currentTimeOfDay?.hourly ?? []
  return Math.max(1, ...hourly.map((h: any) => h.trips || 0))
})

const hourlyYTicks = computed(() => {
  const max = hourlyMax.value
  const niceStep = (m: number): number => {
    if (m <= 4) return 1
    if (m <= 10) return 2
    if (m <= 25) return 5
    if (m <= 50) return 10
    if (m <= 100) return 20
    const pow = Math.pow(10, Math.floor(Math.log10(m)))
    return Math.ceil(m / 5 / pow) * pow
  }
  const step = niceStep(max)
  const top = Math.ceil(max / step) * step
  const ticks: string[] = []
  for (let v = top; v >= 0; v -= step) ticks.push(formatNumber(v))
  return ticks
})

const hourlyNormalized = computed(() => {
  const currentTimeOfDay =
    activeTab.value === 'by-car' ? carTimeOfDay.value : timeOfDay.value
  const hourly = currentTimeOfDay?.hourly ?? []
  const max = hourlyMax.value
  const excluded = currentTimeOfDay?.excluded?.hours || []
  return hourly.map((h: any) => {
    const segKey = h.segment as string
    let color = SEGMENT_COLORS[segKey]
    // Fallback: if segment key doesn't match, use hour-based color
    if (!color) {
      if (h.hour >= 6 && h.hour <= 11) color = SEGMENT_COLORS.morning
      else if (h.hour >= 12 && h.hour <= 16) color = SEGMENT_COLORS.afternoon
      else if (h.hour >= 17 && h.hour <= 22) color = SEGMENT_COLORS.evening
      else color = EXCLUDED_COLOR
    }
    return {
      hour: h.hour,
      trips: h.trips || 0,
      segment: segKey,
      segmentLabel: SEGMENT_LABELS[segKey] || '',
      color: color,
      excluded: excluded.includes(h.hour),
      heightPct: max ? (h.trips || 0) / max : 0,
    }
  })
})

const hoveredHour = ref<any>(null)

const hoveredHourPct = computed(() => {
  const total = totalTodTrips.value
  const v = hoveredHour.value?.trips || 0
  if (!total) return 0
  return Math.round((v / total) * 100)
})

const tooltipAlignClass = (hour: number) => {
  if (hour <= 2) return 'tt-align-left'
  if (hour >= 21) return 'tt-align-right'
  return 'tt-align-center'
}

const loadCarStats = async (carId: string) => {
  const [dateFrom, dateTo] = rangeModel.value || []
  if (!dateFrom || !dateTo) return

  const dateFromString = DateTime.fromJSDate(dateFrom).toFormat('yyyy-MM-dd')
  const dateToString = DateTime.fromJSDate(dateTo).toFormat('yyyy-MM-dd')

  loading.value.carOverview = true
  loading.value.carIntervals = true
  loading.value.carTimeOfDay = true
  error.value = null

  try {
    const [overviewRes, intervalsRes, timeRes] = await Promise.all([
      getOwnerStatisticsByCar(carId, {
        date_from: dateFromString,
        date_to: dateToString,
      }),
      getOwnerTripIntervals({
        date_from: dateFromString,
        date_to: dateToString,
        ev_car_profile_id: carId,
        grouping: intervalsGrouping.value,
      }),
      getOwnerTimeOfDay({
        date_from: dateFromString,
        date_to: dateToString,
        ev_car_profile_id: carId,
      }),
    ])

    carOverview.value = overviewRes.data
    carIntervals.value = intervalsRes.data
    carTimeOfDay.value = timeRes.data
  } catch (e) {
    const err = e as any
    error.value =
      err?.response?.data?.message ||
      err?.message ||
      'Failed to load car statistics'
  } finally {
    loading.value.carOverview = false
    loading.value.carIntervals = false
    loading.value.carTimeOfDay = false
  }
}

const loadCars = async () => {
  loading.value.cars = true
  try {
    const res = await getOwnerStatisticsCars()
    cars.value = res.data?.data || []
  } catch (e) {
    const err = e as any
    console.error('Failed to load cars:', err)
    // Don't set error for cars loading - just log it
  } finally {
    loading.value.cars = false
  }
}

const onCarChanged = () => {
  if (selectedCarId.value) {
    loadCarStats(selectedCarId.value)
  }
}

const handleLogout = () => {
  authStore.signOut()
}

onMounted(() => {
  loadCars()
  loadGeneralStats()
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_button, {
        type: "danger",
        size: "small",
        onClick: handleLogout,
        class: "sign-out-button"
      }, {
        default: _withCtx(() => _cache[9] || (_cache[9] = [
          _createTextVNode(" Sign out ")
        ])),
        _: 1,
        __: [9]
      }),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[13] || (_cache[13] = _createElementVNode("h2", null, "My EV Cars Statistics", -1)),
          _createElementVNode("p", _hoisted_5, [
            _cache[12] || (_cache[12] = _createTextVNode(" Usage, revenue and behavioural insights for your vehicles ")),
            (meta.value?.range?.date_from)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _cache[10] || (_cache[10] = _createTextVNode(" · ")),
                  _createElementVNode("b", null, _toDisplayString(formatDateShort(meta.value.range.date_from)), 1),
                  _cache[11] || (_cache[11] = _createTextVNode(" — ")),
                  _createElementVNode("b", null, _toDisplayString(formatDateShort(meta.value.range.date_to)), 1)
                ], 64))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(presets, (p) => {
                return _createElementVNode("button", {
                  key: p.key,
                  class: _normalizeClass(["preset-btn", { active: activePreset.value === p.key }]),
                  disabled: loading.value.overview,
                  onClick: ($event: any) => (applyPreset(p.key))
                }, _toDisplayString(p.label), 11, _hoisted_9)
              }), 64))
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_el_date_picker, {
                modelValue: rangeModel.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((rangeModel).value = $event)),
                type: "daterange",
                "unlink-panels": "",
                "range-separator": "→",
                "start-placeholder": "From",
                "end-placeholder": "To",
                "value-format": "YYYY-MM-DD",
                format: "YYYY-MM-DD",
                size: "small",
                style: {"width":"260px"},
                "popper-class": "date-popper",
                shortcuts: dateShortcuts,
                onChange: onRangeChanged
              }, null, 8, ["modelValue"]),
              _createVNode(_component_el_button, {
                type: "primary",
                size: "small",
                loading: loading.value.overview,
                onClick: reloadAll
              }, {
                default: _withCtx(() => _cache[14] || (_cache[14] = [
                  _createTextVNode(" Apply ")
                ])),
                _: 1,
                __: [14]
              }, 8, ["loading"])
            ])
          ])
        ])
      ])
    ]),
    (error.value)
      ? (_openBlock(), _createBlock(CommonError, {
          key: 0,
          errorMessage: error.value,
          onRetryPress: reloadAll
        }, null, 8, ["errorMessage"]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_tabs, {
      modelValue: activeTab.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((activeTab).value = $event)),
      class: "stats-tabs"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tab_pane, {
          label: "General",
          name: "general"
        }, {
          default: _withCtx(() => [
            (!error.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  (overview.value || loading.value.overview)
                    ? (_openBlock(), _createElementBlock("section", _hoisted_12, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(kpiList.value, (kpi) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: kpi.key,
                            class: "kpi-card",
                            style: _normalizeStyle({ '--accent': kpi.color })
                          }, [
                            _createElementVNode("div", _hoisted_13, [
                              (_openBlock(), _createBlock(_resolveDynamicComponent(kpi.icon)))
                            ]),
                            _createElementVNode("div", _hoisted_14, [
                              _createElementVNode("div", _hoisted_15, _toDisplayString(kpi.title), 1),
                              _createElementVNode("div", _hoisted_16, [
                                (loading.value.overview)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode("—")
                                    ], 64))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createTextVNode(_toDisplayString(kpi.value), 1)
                                    ], 64))
                              ])
                            ])
                          ], 4))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("section", _hoisted_17, [
                    _createElementVNode("header", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                          _cache[18] || (_cache[18] = _createElementVNode("h3", null, "Intervals between trips", -1)),
                          _createElementVNode("small", _hoisted_21, [
                            _cache[15] || (_cache[15] = _createTextVNode(" Time gap between consecutive finished trips across the fleet. Tiles below summarise ")),
                            _cache[16] || (_cache[16] = _createElementVNode("b", null, "all", -1)),
                            _cache[17] || (_cache[17] = _createTextVNode(" intervals (avg / median / min / max / total count). Chart shows ")),
                            _createElementVNode("b", null, "average interval length per " + _toDisplayString(intervalsGrouping.value === 'monthly'
                          ? 'month'
                          : intervalsGrouping.value === 'weekly'
                          ? 'week'
                          : 'day'), 1),
                            _createTextVNode(" — so its Y-axis maxes out at the biggest per-" + _toDisplayString(intervalsGrouping.value === 'monthly'
                        ? 'month'
                        : intervalsGrouping.value === 'weekly'
                        ? 'week'
                        : 'day') + " average, not the single longest interval. ", 1)
                          ])
                        ]),
                        _createVNode(_component_el_select, {
                          modelValue: intervalsGrouping.value,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((intervalsGrouping).value = $event)),
                          size: "small",
                          style: {"width":"110px"},
                          onChange: _cache[2] || (_cache[2] = ($event: any) => (loadIntervals(true)))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              label: "Daily",
                              value: "daily"
                            }),
                            _createVNode(_component_el_option, {
                              label: "Weekly",
                              value: "weekly"
                            }),
                            _createVNode(_component_el_option, {
                              label: "Monthly",
                              value: "monthly"
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      (loading.value.intervals)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                            _createVNode(_component_el_icon, { class: "is-loading" }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(Loading))
                              ]),
                              _: 1
                            }),
                            _cache[19] || (_cache[19] = _createElementVNode("span", null, "Loading intervals…", -1))
                          ]))
                        : (intervals.value && intervals.value.intervalsCount === 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_24, " No intervals in the selected range — either there are no trips, or each day has only a single trip (intervals need at least 2 trips per day). "))
                          : (intervals.value)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                _createElementVNode("div", _hoisted_25, [
                                  _createElementVNode("div", _hoisted_26, [
                                    _cache[20] || (_cache[20] = _createElementVNode("span", null, "Avg", -1)),
                                    _createElementVNode("b", null, _toDisplayString(formatMinutes(intervals.value.avgIntervalMinutes)), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_27, [
                                    _cache[21] || (_cache[21] = _createElementVNode("span", null, "Median", -1)),
                                    _createElementVNode("b", null, _toDisplayString(formatMinutes(intervals.value.medianIntervalMinutes)), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_28, [
                                    _cache[22] || (_cache[22] = _createElementVNode("span", null, "Min", -1)),
                                    _createElementVNode("b", null, _toDisplayString(formatMinutes(intervals.value.minIntervalMinutes)), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_29, [
                                    _cache[23] || (_cache[23] = _createElementVNode("span", null, "Max", -1)),
                                    _createElementVNode("b", null, _toDisplayString(formatMinutes(intervals.value.maxIntervalMinutes)), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_30, [
                                    _cache[24] || (_cache[24] = _createElementVNode("span", null, "Intervals", -1)),
                                    _createElementVNode("b", null, _toDisplayString(formatNumber(intervals.value.intervalsCount)), 1)
                                  ])
                                ]),
                                (intervals.value.buckets && intervals.value.buckets.length === 1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                      _createElementVNode("div", _hoisted_32, [
                                        _createElementVNode("div", _hoisted_33, " Single " + _toDisplayString(intervalsGrouping.value) + " bucket ", 1),
                                        _createElementVNode("div", _hoisted_34, _toDisplayString(intervals.value.buckets[0].date), 1),
                                        _cache[25] || (_cache[25] = _createElementVNode("div", { class: "sb-sub" }, [
                                          _createTextVNode(" Not enough periods to draw a trend — try a wider date range or finer grouping (e.g. "),
                                          _createElementVNode("b", null, "Daily"),
                                          _createTextVNode("). ")
                                        ], -1))
                                      ]),
                                      _createElementVNode("div", _hoisted_35, [
                                        _createElementVNode("span", null, _toDisplayString(formatMinutes(intervals.value.buckets[0].avg_interval_minutes)), 1),
                                        _createElementVNode("small", null, _toDisplayString(intervals.value.buckets[0].intervals_count) + " intervals", 1)
                                      ])
                                    ]))
                                  : (intervals.value.buckets?.length)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                        _createElementVNode("div", _hoisted_37, [
                                          _cache[27] || (_cache[27] = _createElementVNode("span", { class: "lg-item" }, [
                                            _createElementVNode("span", { class: "lg-bar lg-bar-lo" }),
                                            _createTextVNode(" Below average ")
                                          ], -1)),
                                          _cache[28] || (_cache[28] = _createElementVNode("span", { class: "lg-item" }, [
                                            _createElementVNode("span", { class: "lg-bar lg-bar-hi" }),
                                            _createTextVNode(" Above average ")
                                          ], -1)),
                                          _createElementVNode("span", _hoisted_38, [
                                            _cache[26] || (_cache[26] = _createElementVNode("span", { class: "lg-dash" }, null, -1)),
                                            _createTextVNode(" Period average (" + _toDisplayString(formatMinutes(intervals.value.avgIntervalMinutes)) + ") ", 1)
                                          ]),
                                          (hoveredBar.value)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_39, [
                                                _createElementVNode("b", null, _toDisplayString(hoveredBar.value.label), 1),
                                                _createTextVNode(" · " + _toDisplayString(formatMinutes(hoveredBar.value.value)) + " ", 1),
                                                _createElementVNode("span", {
                                                  class: _normalizeClass(["lg-delta", hoveredBar.value.above ? 'delta-up' : 'delta-down'])
                                                }, _toDisplayString(hoveredBar.value.above ? '▲' : '▼') + " " + _toDisplayString(hoveredBarDeltaPct.value) + "% vs avg ", 3),
                                                _createTextVNode(" · " + _toDisplayString(hoveredBar.value.count) + " intervals ", 1)
                                              ]))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_40, [
                                          _createElementVNode("div", _hoisted_41, [
                                            _createElementVNode("div", _hoisted_42, " Avg per " + _toDisplayString(intervalsGrouping.value === 'monthly'
                            ? 'month'
                            : intervalsGrouping.value === 'weekly'
                            ? 'week'
                            : 'day'), 1),
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(intervalsYTicks.value, (t, i) => {
                                              return (_openBlock(), _createElementBlock("span", { key: i }, _toDisplayString(t), 1))
                                            }), 128))
                                          ]),
                                          _createElementVNode("div", _hoisted_43, [
                                            _createElementVNode("div", _hoisted_44, [
                                              _createElementVNode("div", {
                                                class: "avg-line",
                                                style: _normalizeStyle({ bottom: avgLinePct.value + '%' })
                                              }, [
                                                _createElementVNode("span", _hoisted_45, " avg " + _toDisplayString(formatMinutes(intervals.value.avgIntervalMinutes)), 1)
                                              ], 4),
                                              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (i) => {
                                                return _createElementVNode("div", {
                                                  key: `g${i}`,
                                                  class: "grid-line",
                                                  style: _normalizeStyle({ bottom: i * 25 + '%' })
                                                }, null, 4)
                                              }), 64)),
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(intervalBars.value, (bar, i) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                  key: i,
                                                  class: _normalizeClass(["bar-col", { hovered: hoveredBar.value?.index === i }]),
                                                  onMouseenter: ($event: any) => (hoveredBar.value = { ...bar, index: i }),
                                                  onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (hoveredBar.value = null))
                                                }, [
                                                  _createElementVNode("div", {
                                                    class: _normalizeClass(["bar", bar.above ? 'bar-hi' : 'bar-lo']),
                                                    style: _normalizeStyle({ height: bar.heightPct + '%' })
                                                  }, [
                                                    _createElementVNode("span", _hoisted_47, _toDisplayString(bar.shortValue), 1)
                                                  ], 6)
                                                ], 42, _hoisted_46))
                                              }), 128))
                                            ]),
                                            _createElementVNode("div", _hoisted_48, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(intervalBars.value, (bar, i) => {
                                                return (_openBlock(), _createElementBlock("span", {
                                                  key: i,
                                                  class: _normalizeClass({ hide: !bar.showLabel })
                                                }, _toDisplayString(bar.shortDate), 3))
                                              }), 128))
                                            ])
                                          ])
                                        ])
                                      ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_49, "No data for selected range"))
                              ], 64))
                            : (_openBlock(), _createElementBlock("div", _hoisted_50, "Open to load data"))
                    ])
                  ]),
                  _createElementVNode("section", _hoisted_51, [
                    _cache[36] || (_cache[36] = _createElementVNode("header", { class: "panel-head static" }, [
                      _createElementVNode("div", { class: "panel-title" }, [
                        _createElementVNode("div", { class: "title-with-sub" }, [
                          _createElementVNode("h3", null, "Time of day distribution"),
                          _createElementVNode("small", { class: "desc" }, " Trip distribution across hours of the day. Each hour is colored by its dominant segment (morning / afternoon / evening / night). ")
                        ])
                      ])
                    ], -1)),
                    _createElementVNode("div", _hoisted_52, [
                      (loading.value.timeOfDay)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                            _createVNode(_component_el_icon, { class: "is-loading" }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(Loading))
                              ]),
                              _: 1
                            }),
                            _cache[29] || (_cache[29] = _createElementVNode("span", null, "Loading time of day…", -1))
                          ]))
                        : (timeOfDay.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                              _createElementVNode("div", _hoisted_55, [
                                _createElementVNode("div", {
                                  class: "donut",
                                  style: _normalizeStyle({ background: donutGradient.value })
                                }, [
                                  _createElementVNode("div", _hoisted_56, [
                                    _createElementVNode("span", _hoisted_57, _toDisplayString(totalTodTrips.value), 1),
                                    _cache[30] || (_cache[30] = _createElementVNode("span", { class: "donut-label" }, "trips", -1))
                                  ])
                                ], 4),
                                _createElementVNode("div", _hoisted_58, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(segmentList.value, (s) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: s.key,
                                      class: "segment-item"
                                    }, [
                                      _createElementVNode("span", {
                                        class: "segment-swatch",
                                        style: _normalizeStyle({ background: s.color })
                                      }, null, 4),
                                      _createElementVNode("div", _hoisted_59, [
                                        _createElementVNode("div", _hoisted_60, [
                                          _createElementVNode("b", null, _toDisplayString(s.label), 1),
                                          _createElementVNode("span", null, _toDisplayString(s.percent) + "%", 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_61, _toDisplayString(s.trips) + " trips · " + _toDisplayString(s.revenue.toFixed(2)) + "₼ · " + _toDisplayString(s.avg_duration_minutes.toFixed(1)) + "m avg ", 1)
                                      ])
                                    ]))
                                  }), 128))
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_62, [
                                _createElementVNode("div", _hoisted_63, [
                                  _cache[33] || (_cache[33] = _createElementVNode("div", { class: "hourly-title" }, "Hourly breakdown", -1)),
                                  (excludedTrips.value > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                                        _cache[31] || (_cache[31] = _createElementVNode("span", { class: "oh-dot" }, null, -1)),
                                        _createTextVNode(" Off-hours (" + _toDisplayString(excludedHoursRange.value) + "): ", 1),
                                        _createElementVNode("b", null, _toDisplayString(formatNumber(excludedTrips.value)), 1),
                                        _cache[32] || (_cache[32] = _createTextVNode(" trips "))
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_65, [
                                  _createElementVNode("div", _hoisted_66, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(hourlyYTicks.value, (t, i) => {
                                      return (_openBlock(), _createElementBlock("span", { key: i }, _toDisplayString(t), 1))
                                    }), 128))
                                  ]),
                                  _createElementVNode("div", _hoisted_67, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(hourlyNormalized.value, (h) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: h.hour,
                                        class: _normalizeClass(["hour-col", {
                            'is-excluded': h.excluded,
                            hovered: hoveredHour.value?.hour === h.hour,
                          }]),
                                        onMouseenter: ($event: any) => (hoveredHour.value = h),
                                        onMouseleave: _cache[4] || (_cache[4] = ($event: any) => (hoveredHour.value = null))
                                      }, [
                                        (hoveredHour.value?.hour === h.hour)
                                          ? (_openBlock(), _createElementBlock("div", {
                                              key: 0,
                                              class: _normalizeClass(["hourly-tooltip", tooltipAlignClass(h.hour)])
                                            }, [
                                              _createElementVNode("b", null, _toDisplayString(h.hour) + ":00 – " + _toDisplayString(h.hour) + ":59", 1),
                                              _createElementVNode("span", {
                                                class: "ht-seg",
                                                style: _normalizeStyle({ background: h.color })
                                              }, _toDisplayString(h.segmentLabel), 5),
                                              _cache[34] || (_cache[34] = _createTextVNode(" · ")),
                                              _createElementVNode("b", null, _toDisplayString(h.trips), 1),
                                              _cache[35] || (_cache[35] = _createTextVNode(" trips "))
                                            ], 2))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("div", {
                                          class: "hour-bar",
                                          style: _normalizeStyle({
                              height: h.heightPct * 100 + '%',
                              background: h.color,
                            })
                                        }, null, 4),
                                        _createElementVNode("span", _hoisted_69, _toDisplayString(h.hour), 1)
                                      ], 42, _hoisted_68))
                                    }), 128))
                                  ])
                                ])
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_70, "Open to load data"))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, {
          label: "By car",
          name: "by-car"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_71, [
              _createVNode(_component_el_select, {
                modelValue: selectedCarId.value,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((selectedCarId).value = $event)),
                placeholder: "Select a car",
                filterable: "",
                loading: loading.value.cars,
                style: {"width":"300px"},
                onChange: onCarChanged,
                clearable: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cars.value, (car) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: car.id,
                      label: `${car.model_name} (${car.plate_number})`,
                      value: car.id
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "loading"])
            ]),
            (selectedCarId.value && !error.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                  (carOverview.value || loading.value.carOverview)
                    ? (_openBlock(), _createElementBlock("section", _hoisted_73, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(kpiList.value, (kpi) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: kpi.key,
                            class: "kpi-card",
                            style: _normalizeStyle({ '--accent': kpi.color })
                          }, [
                            _createElementVNode("div", _hoisted_74, [
                              (_openBlock(), _createBlock(_resolveDynamicComponent(kpi.icon)))
                            ]),
                            _createElementVNode("div", _hoisted_75, [
                              _createElementVNode("div", _hoisted_76, _toDisplayString(kpi.title), 1),
                              _createElementVNode("div", _hoisted_77, [
                                (loading.value.carOverview)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode("—")
                                    ], 64))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createTextVNode(_toDisplayString(kpi.value), 1)
                                    ], 64))
                              ])
                            ])
                          ], 4))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  (selectedCarId.value)
                    ? (_openBlock(), _createElementBlock("section", _hoisted_78, [
                        _cache[49] || (_cache[49] = _createElementVNode("header", { class: "panel-head static" }, [
                          _createElementVNode("div", { class: "panel-title" }, [
                            _createElementVNode("div", { class: "title-with-sub" }, [
                              _createElementVNode("h3", null, "Intervals between trips"),
                              _createElementVNode("small", { class: "desc" }, " Time gap between consecutive finished trips for this vehicle. ")
                            ])
                          ])
                        ], -1)),
                        _createElementVNode("div", _hoisted_79, [
                          (loading.value.carIntervals)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                                _createVNode(_component_el_icon, { class: "is-loading" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(Loading))
                                  ]),
                                  _: 1
                                }),
                                _cache[37] || (_cache[37] = _createElementVNode("span", null, "Loading intervals…", -1))
                              ]))
                            : (carIntervals.value && carIntervals.value.intervalsCount === 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_81, " No intervals in the selected range. "))
                              : (carIntervals.value)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                    _createElementVNode("div", _hoisted_82, [
                                      _createElementVNode("div", _hoisted_83, [
                                        _cache[38] || (_cache[38] = _createElementVNode("span", null, "Avg", -1)),
                                        _createElementVNode("b", null, _toDisplayString(formatMinutes(carIntervals.value.avgIntervalMinutes)), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_84, [
                                        _cache[39] || (_cache[39] = _createElementVNode("span", null, "Median", -1)),
                                        _createElementVNode("b", null, _toDisplayString(formatMinutes(carIntervals.value.medianIntervalMinutes)), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_85, [
                                        _cache[40] || (_cache[40] = _createElementVNode("span", null, "Min", -1)),
                                        _createElementVNode("b", null, _toDisplayString(formatMinutes(carIntervals.value.minIntervalMinutes)), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_86, [
                                        _cache[41] || (_cache[41] = _createElementVNode("span", null, "Max", -1)),
                                        _createElementVNode("b", null, _toDisplayString(formatMinutes(carIntervals.value.maxIntervalMinutes)), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_87, [
                                        _cache[42] || (_cache[42] = _createElementVNode("span", null, "Intervals", -1)),
                                        _createElementVNode("b", null, _toDisplayString(formatNumber(carIntervals.value.intervalsCount)), 1)
                                      ])
                                    ]),
                                    (
                    carIntervals.value.buckets && carIntervals.value.buckets.length === 1
                  )
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                                          _createElementVNode("div", _hoisted_89, [
                                            _cache[44] || (_cache[44] = _createElementVNode("div", { class: "sb-label" }, "Selected range", -1)),
                                            _createElementVNode("div", _hoisted_90, _toDisplayString(formatBucketShortDate(carIntervals.value.buckets[0].date)), 1),
                                            _createElementVNode("div", _hoisted_91, [
                                              _createTextVNode(" Average interval for this " + _toDisplayString(intervalsGrouping.value === 'monthly'
                          ? 'month'
                          : intervalsGrouping.value === 'weekly'
                          ? 'week'
                          : 'day') + " is ", 1),
                                              _createElementVNode("b", null, _toDisplayString(formatMinutes(carIntervals.value.avgIntervalMinutes)), 1),
                                              _cache[43] || (_cache[43] = _createTextVNode(" based on ")),
                                              _createElementVNode("b", null, _toDisplayString(carIntervals.value.buckets[0].intervals_count), 1),
                                              _createTextVNode(" interval" + _toDisplayString(carIntervals.value.buckets[0].intervals_count !== 1
                          ? 's'
                          : '') + ". ", 1)
                                            ])
                                          ]),
                                          _createElementVNode("div", _hoisted_92, [
                                            _createElementVNode("span", null, _toDisplayString(formatMinutes(carIntervals.value.avgIntervalMinutes)), 1),
                                            _cache[45] || (_cache[45] = _createElementVNode("small", null, "Avg", -1))
                                          ])
                                        ]))
                                      : (carIntervals.value.buckets?.length)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_93, [
                                            _createElementVNode("div", _hoisted_94, [
                                              _cache[47] || (_cache[47] = _createElementVNode("span", { class: "lg-item" }, [
                                                _createElementVNode("span", { class: "lg-bar lg-bar-lo" }),
                                                _createTextVNode(" Below average ")
                                              ], -1)),
                                              _cache[48] || (_cache[48] = _createElementVNode("span", { class: "lg-item" }, [
                                                _createElementVNode("span", { class: "lg-bar lg-bar-hi" }),
                                                _createTextVNode(" Above average ")
                                              ], -1)),
                                              _createElementVNode("span", _hoisted_95, [
                                                _cache[46] || (_cache[46] = _createElementVNode("span", { class: "lg-dash" }, null, -1)),
                                                _createTextVNode(" Period average (" + _toDisplayString(formatMinutes(carIntervals.value.avgIntervalMinutes)) + ") ", 1)
                                              ]),
                                              (hoveredBar.value)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_96, [
                                                    _createElementVNode("b", null, _toDisplayString(hoveredBar.value.label), 1),
                                                    _createTextVNode(" · " + _toDisplayString(formatMinutes(hoveredBar.value.value)) + " ", 1),
                                                    _createElementVNode("span", {
                                                      class: _normalizeClass(["lg-delta", hoveredBar.value.above ? 'delta-up' : 'delta-down'])
                                                    }, _toDisplayString(hoveredBar.value.above ? '▲' : '▼') + " " + _toDisplayString(hoveredBarDeltaPct.value) + "% vs avg ", 3),
                                                    _createTextVNode(" · " + _toDisplayString(hoveredBar.value.count) + " intervals ", 1)
                                                  ]))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _createElementVNode("div", _hoisted_97, [
                                              _createElementVNode("div", _hoisted_98, [
                                                _createElementVNode("div", _hoisted_99, " Avg per " + _toDisplayString(intervalsGrouping.value === 'monthly'
                            ? 'month'
                            : intervalsGrouping.value === 'weekly'
                            ? 'week'
                            : 'day'), 1),
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(intervalsYTicks.value, (t, i) => {
                                                  return (_openBlock(), _createElementBlock("span", { key: i }, _toDisplayString(t), 1))
                                                }), 128))
                                              ]),
                                              _createElementVNode("div", _hoisted_100, [
                                                _createElementVNode("div", _hoisted_101, [
                                                  _createElementVNode("div", {
                                                    class: "avg-line",
                                                    style: _normalizeStyle({ bottom: avgLinePct.value + '%' })
                                                  }, [
                                                    _createElementVNode("span", _hoisted_102, " avg " + _toDisplayString(formatMinutes(carIntervals.value.avgIntervalMinutes)), 1)
                                                  ], 4),
                                                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (i) => {
                                                    return _createElementVNode("div", {
                                                      key: `g${i}`,
                                                      class: "grid-line",
                                                      style: _normalizeStyle({ bottom: i * 25 + '%' })
                                                    }, null, 4)
                                                  }), 64)),
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(intervalBars.value, (bar, i) => {
                                                    return (_openBlock(), _createElementBlock("div", {
                                                      key: i,
                                                      class: _normalizeClass(["bar-col", { hovered: hoveredBar.value?.index === i }]),
                                                      onMouseenter: ($event: any) => (hoveredBar.value = { ...bar, index: i }),
                                                      onMouseleave: _cache[6] || (_cache[6] = ($event: any) => (hoveredBar.value = null))
                                                    }, [
                                                      _createElementVNode("div", {
                                                        class: _normalizeClass(["bar", bar.above ? 'bar-hi' : 'bar-lo']),
                                                        style: _normalizeStyle({ height: bar.heightPct + '%' })
                                                      }, [
                                                        _createElementVNode("span", _hoisted_104, _toDisplayString(bar.shortValue), 1)
                                                      ], 6)
                                                    ], 42, _hoisted_103))
                                                  }), 128))
                                                ]),
                                                _createElementVNode("div", _hoisted_105, [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(intervalBars.value, (bar, i) => {
                                                    return (_openBlock(), _createElementBlock("span", {
                                                      key: i,
                                                      class: _normalizeClass({ hide: !bar.showLabel })
                                                    }, _toDisplayString(bar.label), 3))
                                                  }), 128))
                                                ])
                                              ])
                                            ])
                                          ]))
                                        : _createCommentVNode("", true)
                                  ], 64))
                                : (_openBlock(), _createElementBlock("div", _hoisted_106, "Open to load data"))
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (selectedCarId.value)
                    ? (_openBlock(), _createElementBlock("section", _hoisted_107, [
                        _cache[55] || (_cache[55] = _createElementVNode("header", { class: "panel-head static" }, [
                          _createElementVNode("div", { class: "panel-title" }, [
                            _createElementVNode("div", { class: "title-with-sub" }, [
                              _createElementVNode("h3", null, "Time of day distribution"),
                              _createElementVNode("small", { class: "desc" }, " Trip distribution across hours of the day for this vehicle. ")
                            ])
                          ])
                        ], -1)),
                        _createElementVNode("div", _hoisted_108, [
                          (loading.value.carTimeOfDay)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_109, [
                                _createVNode(_component_el_icon, { class: "is-loading" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(Loading))
                                  ]),
                                  _: 1
                                }),
                                _cache[50] || (_cache[50] = _createElementVNode("span", null, "Loading time of day…", -1))
                              ]))
                            : (carTimeOfDay.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_110, [
                                  _createElementVNode("div", _hoisted_111, [
                                    _createElementVNode("div", {
                                      class: "donut",
                                      style: _normalizeStyle({ background: donutGradient.value })
                                    }, [
                                      _createElementVNode("div", _hoisted_112, [
                                        _createElementVNode("div", _hoisted_113, _toDisplayString(totalTodTrips.value), 1),
                                        _cache[51] || (_cache[51] = _createElementVNode("div", { class: "donut-label" }, "Trips", -1))
                                      ])
                                    ], 4),
                                    _createElementVNode("div", _hoisted_114, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(segmentList.value, (seg) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: seg.key,
                                          class: "segment-item"
                                        }, [
                                          _createElementVNode("div", {
                                            class: "segment-swatch",
                                            style: _normalizeStyle({ background: seg.color })
                                          }, null, 4),
                                          _createElementVNode("div", _hoisted_115, [
                                            _createElementVNode("div", _hoisted_116, [
                                              _createElementVNode("b", null, _toDisplayString(seg.label), 1),
                                              _createElementVNode("span", null, _toDisplayString(seg.percent) + "%", 1)
                                            ]),
                                            _createElementVNode("div", _hoisted_117, _toDisplayString(seg.trips) + " trips · avg " + _toDisplayString(formatMinutes(seg.avg_duration_minutes)), 1)
                                          ])
                                        ]))
                                      }), 128))
                                    ]),
                                    (excludedTrips.value > 0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_118, [
                                          _cache[52] || (_cache[52] = _createElementVNode("div", { class: "oh-dot" }, null, -1)),
                                          _createTextVNode(" " + _toDisplayString(excludedTrips.value) + " trips excluded (" + _toDisplayString(excludedHoursRange.value) + ") ", 1)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createElementVNode("div", _hoisted_119, [
                                    _createElementVNode("div", _hoisted_120, [
                                      _cache[54] || (_cache[54] = _createElementVNode("div", { class: "hourly-title" }, "Hourly breakdown", -1)),
                                      (excludedTrips.value > 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_121, [
                                            _cache[53] || (_cache[53] = _createElementVNode("div", { class: "oh-dot" }, null, -1)),
                                            _createTextVNode(" " + _toDisplayString(excludedTrips.value) + " trips excluded ", 1)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_122, [
                                      _createElementVNode("div", _hoisted_123, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(hourlyYTicks.value, (t, i) => {
                                          return (_openBlock(), _createElementBlock("span", { key: i }, _toDisplayString(t), 1))
                                        }), 128))
                                      ]),
                                      _createElementVNode("div", _hoisted_124, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(hourlyNormalized.value, (h) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            key: h.hour,
                                            class: _normalizeClass(["hour-col", { 'is-excluded': h.excluded }]),
                                            onMouseenter: ($event: any) => (hoveredHour.value = h.hour),
                                            onMouseleave: _cache[7] || (_cache[7] = ($event: any) => (hoveredHour.value = null))
                                          }, [
                                            _createElementVNode("div", {
                                              class: "hour-bar",
                                              style: _normalizeStyle({
                              background: h.color,
                              height: h.heightPct * 100 + '%',
                            })
                                            }, null, 4),
                                            _createElementVNode("div", _hoisted_126, _toDisplayString(h.hour), 1),
                                            (hoveredHour.value === h.hour)
                                              ? (_openBlock(), _createElementBlock("div", {
                                                  key: 0,
                                                  class: _normalizeClass(["hourly-tooltip", tooltipAlignClass(h.hour)])
                                                }, [
                                                  _createElementVNode("b", null, _toDisplayString(h.hour) + ":00", 1),
                                                  _createTextVNode(" · " + _toDisplayString(h.trips) + " trip" + _toDisplayString(h.trips !== 1 ? 's' : '') + " ", 1),
                                                  _createElementVNode("span", {
                                                    class: "ht-seg",
                                                    style: _normalizeStyle({ background: h.color, color: '#fff' })
                                                  }, _toDisplayString(h.segmentLabel), 5)
                                                ], 2))
                                              : _createCommentVNode("", true)
                                          ], 42, _hoisted_125))
                                        }), 128))
                                      ])
                                    ])
                                  ])
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_127, "Open to load data"))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})